import { createApi } from 'api/common/createApi'

import config, { API_TYPES } from '../constants/app-config'

export const tasAPI = createApi({
  baseURL: config[API_TYPES.TAS_API_URL],
})
